import anneeSemaineToString from '@/services/general/anneeSemaineToString';

export default function validationDeleteFace(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  messages.length = 0;
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;

    if (message.indexOf('FACE_USED_IN_N_CIRCUITS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNCircuits',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_N_CONTRACTS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNContracts',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_N_NETWORKS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNNetworks',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_N_PURCHASE_BILLS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNPurchaseBills',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_N_PURCHASE_ORDERS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNPurchaseOrders',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_N_SELL_BILLS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNSellBills',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_N_SELL_ORDERS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNSellOrders',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_N_SELL_QUOTES') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNSellQuotes',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_N_WEEK_FACE_CIRSUITS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNWeekFaceCircuits',
        parametres: {
          code: elements[1],
          qte: elements[2],
          minAnneeSemaine: anneeSemaineToString(elements[3]),
          maxAnneeSemaine: anneeSemaineToString(elements[4]),
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_1_WEEK_FACE_CIRSUITS') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedIn1WeekFaceCircuits',
        parametres: {
          code: elements[1],
          anneeSemaine: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_N_OT_TECH') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNOtTech',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_LOGISTIC_REQUEST') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInLogisticRequest',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('FACE_USED_IN_DISPOSITIF_PRODUCT') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'listeFace.errors.faceUsedInNDispositifProduct',
        parametres: {
          code: elements[1],
          cmde: elements[2],
        },
      });
    }
  });
}
